module.exports = __webpack_public_path__ + "static/media/equipment32.643a904c.jpg";